import EvaluateProcessor from "../../../core/internal/evaluation/EvaluateProcessor"
import { InAppMessageEligibilityEvaluation } from "../../../core/internal/evaluation/service/inappmessage/eligibility/InAppMessageEligibilityEvaluation"
import { InAppMessageEligibilityLocalEvaluateRequest } from "../../../core/internal/evaluation/service/inappmessage/eligibility/mode/local/InAppMessageEligibilityLocalEvaluateRequest"
import { TrackEvent } from "../../../core/internal/event/UserEvent"
import { HackleUser, InAppMessageConfig } from "../../../core/internal/model/model"
import WorkspaceConfig from "../../../core/internal/workspace/config/WorkspaceConfig"
import WorkspaceConfigFetcher from "../../../core/internal/workspace/config/WorkspaceConfigFetcher"
import { InAppMessageEventMatcher } from "./InAppMessageEventMatcher"
import { AbstractInAppMessageTriggerDeterminer } from "./InAppMessageTriggerDeterminer"

export class LocalInAppMessageTriggerDeterminer extends AbstractInAppMessageTriggerDeterminer<
  WorkspaceConfig,
  InAppMessageConfig
> {
  constructor(
    protected readonly eventMatcher: InAppMessageEventMatcher,
    private readonly workspaceFetcher: WorkspaceConfigFetcher,
    private readonly evaluateProcessor: EvaluateProcessor
  ) {
    super()
  }

  protected workspace(user: HackleUser): WorkspaceConfig | null {
    return this.workspaceFetcher.workspace(user)
  }

  protected evaluate(
    workspace: WorkspaceConfig,
    message: InAppMessageConfig,
    event: TrackEvent
  ): InAppMessageEligibilityEvaluation {
    const request = new InAppMessageEligibilityLocalEvaluateRequest(
      workspace,
      event.user,
      message,
      "TRIGGER",
      "WEB",
      event.timestamp
    )
    return this.evaluateProcessor.inAppMessageEligibility(request).evaluation
  }
}
